var _style, _g, _g2, _g3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruckGreen(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 844 480",
    style: {
      enableBackground: "new 0 0 844 480",
      fill: "green"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#191919;fill-opacity:0.9961;enable-background:new    ;}\n\t.st1{fill-opacity:0.9961;stroke:#191919;stroke-width:6;}\n\t.st2{fill:#262626;}\n\t.st3{fill:#191919;stroke:#262626;stroke-width:5;}\n\t.st4{fill:#262626;fill-opacity:0.9961;stroke:#191919;stroke-width:5;enable-background:new    ;}\n\t.st5{opacity:0.5;fill:none;stroke:#292929;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;enable-background:new    ;}\n\t.st6{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M560.2,97.1H45.7c-9.7,0-17.7,6.4-17.7,14.2V240v128.8c0,7.8,7.9,14.2,17.7,14.2h514.6 c9.7,0,17.7-6.4,17.7-14.2V240V111.2C577.9,103.4,569.9,97.1,560.2,97.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M766,108.1c-58.7,0-188.1,6.3-188.1,6.3V240v125.6c0,0,129.4,6.3,188.1,6.3S821.3,240,821.3,240 S824.7,108.1,766,108.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M658,122.2c0,0-16.2,18.9-47,18.9c0,0-23.7,1.2-23.7-15.3L658,122.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M670.7,123.1l13.3-4c0,0-4-42.7-22.7-37.3L670.7,123.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M658,357.8c0,0-16.2-18.9-47-18.9c0,0-23.7-1.2-23.7,15.3L658,357.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M670.7,356.9l13.3,4c0,0-4,42.7-22.7,37.3L670.7,356.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M688.5,134.9c0,0-69.5,12-67,17s5.5,88,5.5,88s-3,83-5.5,88c-2.5,5,67,17,67,17s18-48,18-105 C706.5,182.9,688.5,134.9,688.5,134.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.1,
    y: 110.4,
    width: 101.3,
    height: 254.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.2,
    y: 110.7,
    width: 87.6,
    height: 254.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.7,
    y: 110.7,
    width: 87.6,
    height: 254.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.9,365.5H62.5c-7.8,0-14.2-6.3-14.2-14.2V124.9c0-7.8,6.3-14.2,14.2-14.2h73.4V365.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.6,110.7H549c7.8,0,14.2,6.3,14.2,14.2v226.4c0,7.8-6.3,14.2-14.2,14.2h-73.4V110.7z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 713.5,
    y1: 175.9,
    x2: 802,
    y2: 167.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 713.5,
    y1: 303.9,
    x2: 802,
    y2: 312.4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M451.2,258.7l-195.5,89.6v-43.2l151.1-64.8v-0.8l-151.1-64.8v-43.2l195.5,89.6V258.7z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckGreen);
export default __webpack_public_path__ + "static/media/truck-green.5cbdc0b489f4bd6050b6426d17bed51d.svg";
export { ForwardRef as ReactComponent };